import * as React from 'react';
import {classNames} from '@shopify/react-utilities/styles';

import {Icon} from 'components/UIKit';
import {SocialAccounts} from '../../interfaces';
import styles from './NavSocialLink.scss';

type AnchorElementProps = JSX.IntrinsicElements['a'];

interface NavSocialLinkProps extends AnchorElementProps {
  name: SocialAccounts;
  text: string;
  url: string;
}

export function NavSocialLink({name, text, url, ...restProps}: NavSocialLinkProps) {
  return (
    <a
      className={classNames(styles.navSocialLink, styles[name])}
      target="_blank"
      rel="me"
      data-ga-event="Social"
      data-ga-action={name}
      data-ga-label="NavDrawer"
      href={url}
      {...restProps}
    >
      <Icon icon={name} alt={text} size={20} fill="white" />
    </a>
  );
}

export default NavSocialLink;
